export const languages = {
  ES: 'es',
  EN: 'en',
};
